import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { deepCopy } from '@delon/util';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AsnService extends BaseService {

  private url = 'api/asn';
  private needDetails: any = [];

  constructor(http: HttpClient) {
    super(http);
  }


  getUrl(): string {
    return this.url;
  }

  /**
   * 查询待办
   * @param params
   */
  queryTodo(params: HttpParams): Observable<any> {
    const url = `${this.getUrl()}/todo`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }
  //撤回
  /*goBack(asn: any): Observable<any> {
    const url = `${this.getUrl()}/go-back`;
    return this.http.put<any>(url, asn, httpOptions).pipe(
      tap(_ => this.log(`goBack`)),
      catchError(
        this.handleError<any>('goBack'),
      ),
    );
  }*/
  recall(params): Observable<any> {
    const url = `${this.getUrl()}/goBack`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params: params,
      }
    ).pipe(
      tap(() => this.log('goBack')),
      catchError(this.handleError('goBack'))
    );
  }
  //打印箱条码
  printBarCode(object: any): Observable<any> {
    const url = `${this.getUrl()}/print-bar-code`;
    return this.http.put<any>(url, object, httpOptions).pipe(
      tap(_ => this.log(`printBarCode object =${object}`)),
      catchError(
        this.handleError<any>('printBarCode'),
      ),
    );
  }


  getNeedDetails(): any {
    let data = this.needDetails;
    this.needDetails = [];
    return data;
  }

  setNeedDetails(data) {
    this.needDetails = deepCopy(data);
    // 200000
    this.needDetails.forEach(item => {
      item.poNo = item.purOrderDetail.purOrder.orderNo;
      item.poItemNo = item.purOrderDetail.itemNo;
      item.deliveryDate = item.requireGoodsDateFrom;
      item.requireQty = item.confirmCount;
      item.delQty = item.requireQty - item.asnCrtQty - item.asnReceiveQty;
      item.shipAddress = item.purOrderDetail.purOrder.shipAddress;
      item.plant = item.purOrderDetail.plant;
      item.supplier = item.purOrderDetail.purOrder.supplier;
      item.materialName = item.purOrderDetail.materialName;
      item.material = item.purOrderDetail.material;
      if(item.purOrderDetail.material){
        item.minPackNum = item.purOrderDetail.material.minPackNum;
        if (item.minPackNum) {
          //向上取整
          item.boxQty = Math.ceil(item.delQty / item.minPackNum);
        }
      }


      item.unit = item.purOrderDetail.orderUnit;
      item.checked = false;
      if (item.planType == 'confirm') {
        item.requireGoodsPlanRow = { id: item.id };
      }
      item.fkId = item.id;
      if(item.purOrderDetail.plant) {
        item.plantName = item.purOrderDetail.plant.plantName + "_" + item.purOrderDetail.plant.plantCode;
      }
      if(item.purOrderDetail.storageLocation) {
        item.addresses = item.purOrderDetail.storageLocation.storageLocationName + "_" + item.purOrderDetail.storageLocation.storageLocationCode;
      }
      delete item.id;
    });
  }


  printAsnCode = 'LODOP.PRINT_INIT("");\n' +
    '    LODOP.SET_PRINT_PAGESIZE(2, "210mm", "297mm", "");\n' +
    '    LODOP.ADD_PRINT_TABLE(185, "3%", "90%", 330, {{asnHtmls[1]}});\n' +
    '    LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);\n' +
    '    LODOP.ADD_PRINT_HTM(20, "3%", "90%", 160, {{asnHtmls[0]}});\n' +
    '    LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);\n' +
    '    LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);\n' +
    '    LODOP.ADD_PRINT_BARCODE(5, "3%", 250, 50, \'128Auto\', {{asn.asnNo}});\n' +
    '    LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);\n' +
    '    LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);\n' +
    '    LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);';
  barCodePrintCode: string = 'LODOP.PRINT_INIT("");\n' +
    'LODOP.SET_PRINT_PAGESIZE(1,780,280,"");\n' +
    'LODOP.ADD_PRINT_BARCODE(7,185,95,95,"QRCode","1231231312");\n' +
    'LODOP.SET_PRINT_STYLEA(0,"FontSize",8);\n' +
    'LODOP.SET_PRINT_STYLEA(0,"QRCodeVersion",7);\n' +
    'LODOP.ADD_PRINT_RECT(0,0,295,106,0,1);\n';

  getAsnHtmls(asn) {
    var asnHeaderHtmlTemplate = '<style>    *{        font-size: 14px;    }    .header-left-key {        display: inline-block;        float: left;        padding-left: 0px;        line-height: 23px;    }    .header-right-value {        display: inline-block;        float: right;        padding-right: 40px;        line-height: 23px;    }</style><DIV style="LINE-HEIGHT:24px;font-size: 24px;margin-bottom: 15px;" align="center"><STRONG style="font-size: 24px;">上海九翊SRM管理平台</STRONG></DIV><TABLE border="0" cellSpacing="0" cellPadding="0" width="100%"><TBODY><TR><TD width="33%"><span class="header-left-key">单据号：</span><span            class="header-right-value">PRINT_HEADER_VALUE_A</span></TD><TD width="33%"><span class="header-left-key">日期：</span><span            class="header-right-value">PRINT_HEADER_VALUE_B</span></TD><TD width="33%"><span class="header-left-key">采购类型：</span><span            class="header-right-value">PRINT_HEADER_VALUE_C</span></TD></TR><TR><TD width="33%"><span class="header-left-key">预计发货日期：</span><span class="header-right-value">PRINT_HEADER_VALUE_D</span></TD><TD width="33%"><span class="header-left-key">预计到货日期：</span><span class="header-right-value">PRINT_HEADER_VALUE_E</span></TD><TD width="33%"><span class="header-left-key">供应商：</span><span            class="header-right-value">PRINT_HEADER_VALUE_F</span></TD></TR><TR><TD width="33%"><span class="header-left-key">运输方式：</span><span            class="header-right-value">PRINT_HEADER_VALUE_G</span></TD><TD width="33%"><span class="header-left-key">快递单号：</span><span            class="header-right-value">PRINT_HEADER_VALUE_H</span></TD><TD width="33%"><span class="header-left-key">到货地址：</span><span            class="header-right-value">PRINT_HEADER_VALUE_I</span></TD></TR><TR><TD width="33%"><span class="header-left-key">币种：</span><span            class="header-right-value">PRINT_HEADER_VALUE_J</span></TD><TD width="33%"><span class="header-left-key">汇率：</span><span            class="header-right-value">PRINT_HEADER_VALUE_K</span></TD><TD width="33%"><span class="header-left-key">生单状态：</span><span            class="header-right-value">PRINT_HEADER_VALUE_L</span></TD></TR><TR><TD width="33%"><span class="header-left-key">采购组织：</span><span            class="header-right-value">PRINT_HEADER_VALUE_M</span></TD><TD colspan="2"><span class="header-left-key">备注：</span><span class="header-right-value">PRINT_HEADER_VALUE_N</span></TD></TR></TBODY></TABLE>';
    var asnBodyHtmlTopTemplate = '<style>    *{        font-size: 14px;    }    table, tr, td {        -ms-word-break: break-all;        word-break: break-all;    }</style><TABLE border="1" cellSpacing="1" cellPadding="0" width="100%" style="border-collapse:collapse;" bordercolor="#000000"><thead><TR><TD width="8%"><DIV align="center"><b>存货编码</b></DIV></TD><TD width="8%"><DIV align="center"><b>存货名称</b></DIV></TD><TD width="8%"><DIV align="center"><b>销售订单</b></DIV></TD><TD width="9%"><DIV align="center"><b>规格型号</b></DIV></TD><TD width="5%"><DIV align="center"><b>主计量单位</b></DIV></TD><TD width="15%"><DIV align="center"><b>主要参数</b></DIV></TD><TD width="6%"><DIV align="center"><b>订单数量</b></DIV></TD><TD width="6%"><DIV align="center"><b>本次发货数量</b></DIV></TD><TD width="8%"><DIV align="center"><b>采购订单</b></DIV></TD><TD width="5%"><DIV align="center"><b>生产日期</b></DIV></TD><TD width="8%"><DIV align="center"><b>供应商生产批次</b></DIV></TD><TD width="8%"><DIV align="center"><b>SAP批次</b></DIV></TD><TD width="6%"><DIV align="center"><b>备注</b></DIV></TD></TR></thead><TBODY>';
    var asnBodyHtmlLineTemplate = '<TR><TD align="center">PRINT_TABLE_VALUE_A</TD><TD>PRINT_TABLE_VALUE_B</TD><TD align="center">PRINT_TABLE_VALUE_N</TD><TD>PRINT_TABLE_VALUE_C</TD><TD align="center">PRINT_TABLE_VALUE_D</TD><TD>PRINT_TABLE_VALUE_E</TD><TD align="right">PRINT_TABLE_VALUE_F</TD><TD align="right">PRINT_TABLE_VALUE_G</TD><TD align="center">PRINT_TABLE_VALUE_H</TD><TD>PRINT_TABLE_VALUE_J</TD><TD>PRINT_TABLE_VALUE_K</TD><TD align="center">PRINT_TABLE_VALUE_L</TD><TD>PRINT_TABLE_VALUE_M</TD></TR>';
    var asnBodyHtmlFootTemplate = '</TBODY> <tfoot> <tr style="height: 20px;"> <TD colspan="13" style="height: 20px;"> <div style="position: relative;width: 100%;height: 20px;"> <div style="position: absolute;background-color: #fff;width: 110%;height: 22px;left:-5%;"> <span style="display: inline-block;float: left;margin-left: 5%;">制单人：PRINT_FOOTER_VALUE_A</span> <span style="display: inline-block;float: right;margin-right: 5%;"> <span tdata="pageNO" format="#">第 # 页，</span> <span tdata="pageCount" format="#">总 ## 页</span> </span> </div> </div> </TD> </tr> </tfoot> </TABLE>';
    var asnHeaderHtml = '';
    var asnBodyHtml = '';
    //var asnFooterHtml = "";

    asnHeaderHtml = asnHeaderHtmlTemplate;
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_A', asn.asnNo);
    //asnHeaderHtml = asnHeaderHtml.replace("PRINT_HEADER_VALUE_B", asn.releaseTime.substring(0, 10));
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_C', asn.supTypeName);//供应商类型
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_D', asn.actDeldate);
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_E', asn.expArrdate);
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_F', asn.supplierName);
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_G', asn.shipMethodName);//送货方式
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_H', asn.expressNo);//快递单号
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_I', '');//到货地址
    //asnHeaderHtml = asnHeaderHtml.replace("PRINT_HEADER_VALUE_J", asn.orderCurrency);//币种
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_J', '');//币种
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_K', '');//汇率
    var shStr = '未生单';
    if (asn.dsState == '103') {
      shStr = '已生单';
    }
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_L', shStr);//是否收货,生单状态
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_M', asn.purorgName);//采购组织
    asnHeaderHtml = asnHeaderHtml.replace('PRINT_HEADER_VALUE_N', '');//备注
    asnHeaderHtml = asnHeaderHtml.replace('null', '');
    asnHeaderHtml = asnHeaderHtml.replace('undefined', '');
    asnBodyHtml += asnBodyHtmlTopTemplate;
    for (var i = 0; i < asn.orderDetails.length; i++) {
      var asnDt = asn.orderDetails[i];
      var asnBodyHtmlLine = asnBodyHtmlLineTemplate;
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_A', asnDt.matCode);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_B', asnDt.matName);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_C', asnDt.specModel);//规格型号
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_D', asnDt.meaunit);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_E', asnDt.mainPara);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_F', asnDt.poQty);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_G', asnDt.delQty);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_H', asnDt.poNo + '/' + asnDt.poItemNo);
      //asnBodyHtmlLine = asnBodyHtmlLine.replace("PRINT_TABLE_VALUE_I", asnDt.poItemno);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_J', asnDt.supProdate);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_K', asnDt.supProbatch);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_L', asnDt.sapBatch);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_M', asnDt.itemDesc);
      var soNoStr = '';
      if (asnDt.soNo != null) {
        soNoStr = asnDt.soNo + '/' + asnDt.soItemno;
      }
      asnBodyHtmlLine = asnBodyHtmlLine.replace('PRINT_TABLE_VALUE_N', soNoStr);
      asnBodyHtmlLine = asnBodyHtmlLine.replace('null', '');
      asnBodyHtmlLine = asnBodyHtmlLine.replace('undefined', '');
      asnBodyHtml += asnBodyHtmlLine;
    }
    var asnBodyHtmlFoot = asnBodyHtmlFootTemplate;
    asnBodyHtmlFoot = asnBodyHtmlFoot.replace('PRINT_FOOTER_VALUE_A', asn.supplierName);
    asnBodyHtml += asnBodyHtmlFoot;

    //asnFooterHtml = asnFooterHtmlTemplate;

    var asnHtmls = [];
    asnHtmls[0] = asnHeaderHtml;
    asnHtmls[1] = asnBodyHtml;
    // asnHtmls[2] = asnFooterHtml;

    return asnHtmls;
  }
}
